/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
function PageList() {
  const navigate = useNavigate();
  const pageDetails = {
    Title: "Platform service agreement",
    Slug: "platform-service-agreement",
    Content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    "Meta Title": "",
    "Meta Description": "",
    "Meta Tags": "",
    "Hindi Content": "",
    Status: "Active",
  };
  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "title",
      headerName: "Title",
      width: 150,
      editable: true,
    },
    {
      field: "content",
      headerName: "Content",
      width: 150,
      editable: true,
    },

    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: true,
    },
    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip
                onClick={() => navigate("/view_details", { state: pageDetails })}
                title="view"
              >
                <IconButton>
                  <MdOutlinePreview style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip onClick={() => navigate("/edit-manage-page")} title="Edit">
                <IconButton>
                  <FaEdit style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton>
                  <MdDelete style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  const rows = [
    {
      id: 1,
      title: "Platform service agreement",
      content: "test content",
      status: "Active",
    },
    {
      id: 2,
      title: "Software license agreement",
      content: "test content",
      status: "Active",
    },
    {
      id: 3,
      title: "License information",
      content: "test content",
      status: "Active",
    },
    {
      id: 4,
      title: "Exchange rules",
      content: "test content",
      status: "Active",
    },
    {
      id: 5,
      title: "Copyright information",
      content: "test content",
      status: "Active",
    },
    {
      id: 6,
      title: "1",
      content: "test content",
      status: "Active",
    },
    {
      id: 7,
      title: "1",
      content: "test content",
      status: "Active",
    },
    {
      id: 8,
      title: "1",
      content: "test content",
      status: "Active",
    },
    {
      id: 9,
      title: "1",
      content: "test content",
      status: "Active",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box sx={{ height: 598, width: "100%", background: "white" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PageList;
